const UI_MODULES = {
  '@refapp/ui-store-locator': () => import('@refapp/ui-store-locator'),
  '@refapp/ui-banner': () => import('@refapp/ui-banner'),
  '@refapp/ui-before-after': () => import('@refapp/ui-before-after'),
  default: () => Promise.reject(new Error('Loader function is not specified for the module')),
};

export default async function loadUIModules(modules, app) {
  const promises = modules.map((module) => {
    const loaderFn = UI_MODULES[module] || UI_MODULES.default;
    return loaderFn();
  });

  (await Promise.allSettled(promises)).forEach((result, index) => {
    const module = modules[index];
    if (result.status === 'fulfilled') {
      app.use(result.value.default);
    } else {
      console.warn(`Failed to load ${module}:`, result.reason?.message || result.reason);
    }
  });
}
